{/*Public Constant Data */}


{/*Home page list of menu items */}

export const companyName = [
    {id:"company0001", name:"Metaxy Labs Inc.", urlName:"metaxylabs", address:{USA:"447 Broadway, New York, NY 10013", HK:"", UK:""}, email:"du.xian@hotmail.com", phone:"+1 (917) 456-8962"},
    {id:"company0002", name:"Zeela Technologies, Inc.", urlName:"zeela", address:{USA:"1178 Broadway, 3rd Floor #3957, New York, NY 10001", HK:"Hong Kong"}, email:"admin_yxu@Looomiie.com", phone:""},
    {id:"company0003", name:"Fixdpoint Ltd", urlName:"fixdpoint", address:{USA: "1178 Broadway, 3rd Floor #3957, New York, NY 10001", UK:"167-169 Great Portland Street , 5th Floor, London, W1W 5PF"} , email:"admin_yxu@Looomiie.com", phone:""}, 
    {id:"company0004", name:"Metaxy", urlName:"metaxy", address:{USA:"447 Broadway, New York, NY 10013", HK:"Hong Kong", UK:""}, email:"contact@metaxyglobal.com", phone:"+1 (917) 456-8962"}
]

export const productName = [
    {id:"product0001", name:"Metaxy", urlName:"Metaxy"},
    {id:"product0002", name:"Zeela", urlName:"zeela"}
]
export const founderName = [
    {id:"founder0001", name:"Yiwei Wang"},
]

export const menuList = [
    {"_id":"menuList000001","name":"About Us", "label":"AboutUs", "sublist":[] },
    {"_id":"menuList000002","name":"Products", "label":"Products","sublist":productName},
    {"_id":"menuList000003","name":"Services", "label":"Services","sublist":[
                                    {"_id":"menuList000031","name":"ML Dataset Labeling by Accounting Professional","label":"labeling","sublist":[], "urlName":"Labeling"}, 
                                    {"_id":"menuList000032","name":"ML Model Training", "label":"modelTraining","sublist":[{"_id":"menuList000031","name":"test","label":"labeling","sublist":[], }],"urlName":"mltraining"}
                                  ]},
    {"_id":"menuList000004","name":"Publications", "label":"Publications","sublist":[{"_id":"menuList000041","name":"Articles", "label":"Articles","sublist":[], "urlName":"articles"}]}

]




